import {getIamBackendAxios} from "../main";

export default class IamBackendService {
    sendCoockie() {
        return getIamBackendAxios().get('/api/v1/external-services/cofanet/get-subscriber', {withCredentials: true}).then(result => {
            return result.data;
        }).catch(e => {
            console.error("error: " + e)
            throw e;
        });
    }
}
